var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-space-between",staticStyle:{"position":"relative"}},[(true)?[_c('router-view')]:_vm._e(),_vm._v(" "),_c('v-overlay',{attrs:{"value":!_vm.allowedSite()}},[_c('SelectSiteContainer')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }